import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import GlobalActions from 'store/redux/global'
import UIActions from 'store/redux/ui'
import { translate } from 'react-i18next'
import { Icon, Text } from 'components'
import { priceFormatted } from 'utils/string'
import { flatten } from 'lodash'
import PHASE, { phaseToNumber, isAfter, isAfterOrEqual } from 'utils/constants/phases'
import { BreadCrumb } from './BreadCrumb/BreadCrumb'
import { Timer } from './Timer'
import './StatusBar.css'

@connect(
    state => ({
        hasNickname: !!(state.auth.player || {}).nickname,
        phaseInfo: state.phaseInfo,
        isAMToolAvailable: state.phaseInfo.AMTool,
        isAMToolActive: state.phase.isAMToolActive,
        credits: state.phase.credits
    }),
    {
        toogleAMTool: PhaseActions.toogleAMTool,
        toggleCurrentSelectionModal: UIActions.toggleCurrentSelectionModal,
        modalInfo: GlobalActions.info
    }
)
@translate()
export class StatusBar extends PureComponent {
    componentWillMount() {
        this.refreshBreadcrumb(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.phaseInfo !== this.props.phaseInfo) {
            this.refreshBreadcrumb(nextProps)
        }
    }
    refreshBreadcrumb = props => {
        const {
            phaseInfo: { season, race, phase },
            t
        } = props
        if (typeof season === 'number' && typeof race === 'number' && phase) {
            this.breadCrumbItems = flatten([
                race === 1 && phase !== PHASE.POST_SEASON ? t('statusBar.breadCrumb.step1') : [],
                t('statusBar.breadCrumb.step2'),
                t('statusBar.breadCrumb.step3'),
                t('statusBar.breadCrumb.step4'),
                phase === PHASE.POST_SEASON ? t('statusBar.breadCrumb.step5') : []
            ])
            this.phaseNumber = phaseToNumber(phase)
            this.breadCrumbCurrent = race === 1 && phase !== PHASE.POST_SEASON ? this.phaseNumber : this.phaseNumber - 1
        } else {
            this.breadCrumbItems = null
            this.phaseNumber = 0
        }
    }

    handleAMToolClick = () => {
        const { isAMToolAvailable, isAMToolActive, toogleAMTool, modalInfo, t } = this.props
        if (isAMToolAvailable || isAMToolActive) {
            toogleAMTool()
        } else if (!isAMToolAvailable) {
            modalInfo({
                title: t('modals.AMToolNotAvailable.title'),
                text: t('modals.AMToolNotAvailable.text')
            })
        }
    }

    render() {
        const {
            hasNickname,
            phaseInfo: { phase, remainingSeconds, totalSeasons, totalRaces, season, race },
            isAMToolAvailable,
            credits,
            isAMToolActive,
            toggleCurrentSelectionModal,
            t
        } = this.props
        const isAfterPreSeason = isAfter(this.phaseNumber, PHASE.PRE_SEASON)
        return (
            <div className={['StatusBar', { Hide: !(phase && isAfterOrEqual(this.phaseNumber, PHASE.INTRO) && hasNickname) }]}>
                <div className="StatusBar-Content flex row-stretch-center">
                    {this.breadCrumbItems && (
                        <div>
                            <Text className="StatusBar-SeasonRace">
                                <strong>{t('statusBar.season', { current: season, total: totalSeasons })}:</strong>&nbsp;&nbsp;
                                {t('statusBar.race', { current: race, total: totalRaces })}
                            </Text>
                            <BreadCrumb items={this.breadCrumbItems} current={this.breadCrumbCurrent} />
                        </div>
                    )}
                    <div className="flex row-stretch-center">
                        <a className={['StatusBar-AMTool', { Active: isAMToolActive, Disabled: !isAMToolAvailable }]} onClick={this.handleAMToolClick}>
                            <Icon name="amtool" />
                        </a>
                        <a
                            className={['StatusBar-Help', { Hide: !isAfterPreSeason }]}
                            onClick={isAfterPreSeason ? toggleCurrentSelectionModal : null}
                        >
                            <Icon name="help" />
                        </a>
                    </div>
                    <div className="flex row-stretch-center">
                        {typeof credits === 'number' && (
                            <div id="tour-step-1" className={['StatusBar-Credits', { Negative: credits < 0 }]}>
                                <Icon name="dollar" />
                                <span>{priceFormatted(credits).substr(1)}</span>
                            </div>
                        )}
                        {typeof remainingSeconds === 'number' && (
                            <Timer initial={remainingSeconds} />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/StatusBar.js